import { Grid, Typography } from '@mui/material'

interface IContainerStatusProps {
  bookingStatus?: string
}

const ContainerStatus = (props: IContainerStatusProps) => {
  const { bookingStatus } = props

  return (
    <Grid item>
      {bookingStatus && (
        <Typography variant='h5' color='secondary' textAlign='end'>
          {bookingStatus}
        </Typography>
      )}
    </Grid>
  )
}

export default ContainerStatus
